import GallerySlider from "components/GallerySlider/GallerySlider";
import { currency } from "functions/redux/general/action";
import { FC } from "react";
import { TripTypeBadge } from "./FullTripCard";
import { StarIcon } from "@heroicons/react/solid";

const OtherTripCard: FC<{ item: any, imgHeightClass?: string, hideBadge?: boolean }> = ({ item, imgHeightClass = '', hideBadge = false }) => {
    
    if (item.file.length > 1) {
        item.file.pop()
    }
    
    return (
        <a key={item.id}
            href={`detail?q=${item.slug}`}
            className={` flex flex-col h-full mr-4 border border-neutral-100 rounded-md w-96 relative`}
        >
            <div className={` w-full flex flex-1 flex-col  mb-2`}>

                <div className={`px-3  mb-2 w-full ${imgHeightClass}`}>
                    <div className={`w-full mt-2  ${imgHeightClass}	h-32 relative`}>
                        <GallerySlider
                            galleryImgs={item.file}
                            className="w-full h-full object-cover rounded-lg overflow-hidden"
                        />
                    </div>
                    <div className="w-28 top-2 right-4 absolute">
                        <TripTypeBadge item={item} />
                    </div>
                </div>
                {/* {hideBadge === false && ( */}

                <div className="px-3 flex-1">
                    <h2 className="text-md font-medium  capitalize line-clamp-1">
                        {item.isOpenTrip ? item.title : item.country.name}
                    </h2>


                    <p className="text-xs md:text-sm text-gray-600 line-clamp-2">
                        {`${item.productLocation.length} ${item.isOpenTrip ? 'place(s) to visit' : 'place(s) suggested'}`}
                    </p>
                </div>
            </div>
            <div className={`bg-gray-50 border-t-2 border-solid border-gray-100 rounded-lg flex flex-row p-2 flex`}>
                <div className="flex-1 space-y-1 mb-1">
                    <p className="text-xs font-medium text-gray-400 text-center ">Service fee</p>
                    <p className="text-md md:text-lg font-medium text-primary-6000 text-center ">{currency(item.totalPrice)}
                        <span className="text-xs font-medium text-gray-400 text-center ">/ day</span>
                    </p>

                </div>
                <div className="flex-1 space-y-1">
                    <p className="text-xs font-medium text-gray-400 text-center ">Review</p>
                    <div className="flex flex-row justify-center items-center">
                        <StarIcon height={20} color="#FAB005" />
                        <span className="text-xs">No Review</span>
                    </div>
                </div>
            </div>
        </a>
    );
}


export default OtherTripCard;